module.exports = __webpack_public_path__ + "static/media/WuerthExtraBoldCond.540fcd79.ttf";